module.exports = __webpack_public_path__ + "img/icone-blockchain.b7973289.png";